<div class="dtp-host">
  @if (cell()) {
    <button
      class="dtp-trigger-cell mis-cell-field"
      type="button"
      aria-haspopup="dialog"
      [attr.aria-expanded]="open()"
      [attr.aria-label]="ariaLabel() + ' ' + displayDateTime()"
      [attr.title]="displayDateTime()"
      (click)="toggle()"
    >
      <i class="ri-calendar-line dtp-trigger-cell__icon" aria-hidden="true"></i>
      <span class="dtp-trigger-cell__value">{{ displayDateTime() }}</span>
    </button>
  } @else if (compact()) {
    <button
      class="dtp-trigger-icon"
      type="button"
      aria-haspopup="dialog"
      [attr.aria-expanded]="open()"
      [attr.aria-label]="compactAriaLabel()"
      [attr.title]="compactTitle()"
      (click)="toggle()"
    >
      <i class="ri-calendar-line text-base" aria-hidden="true"></i>
    </button>
  } @else {
    <button
      class="dtp-trigger"
      type="button"
      aria-haspopup="dialog"
      [attr.aria-expanded]="open()"
      [attr.aria-label]="ariaLabel() + ' ' + displayDateTime()"
      (click)="toggle()"
    >
      <i class="ri-calendar-line text-sm" aria-hidden="true"></i>
      {{ displayDateTime() }}
    </button>
  }
</div>

<ng-template #dropdownTpl>
  <div
    class="dtp-dropdown"
    role="dialog"
    [attr.aria-label]="ariaLabel()"
    [style.top.px]="dropdownTop() ?? null"
    [style.bottom.px]="dropdownBottom() ?? null"
    [style.left.px]="dropdownLeft() ?? null"
  >
      <div class="dtp-nav">
        <button
          type="button"
          class="dtp-nav-btn"
          aria-label="Předchozí měsíc"
          (click)="prevMonth()"
        >
          <i class="ri-arrow-left-s-line text-sm" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="dtp-month-label dtp-month-label-btn"
          [attr.aria-pressed]="mode() === 'years'"
          aria-label="Vybrat rok"
          (click)="toggleYears()"
        >
          {{ viewMonthLabel() }}
          <i class="ri-arrow-down-s-line text-sm" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="dtp-nav-btn"
          aria-label="Další měsíc"
          (click)="nextMonth()"
        >
          <i class="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
        </button>
      </div>

      @if (mode() === 'years') {
        <div class="dtp-years">
          <div class="dtp-nav dtp-years-nav">
            <button
              type="button"
              class="dtp-nav-btn"
              aria-label="Předchozí roky"
              (click)="prevYears()"
            >
              <i class="ri-arrow-left-s-line text-sm" aria-hidden="true"></i>
            </button>
            <span class="dtp-years-label">{{ yearsLabel() }}</span>
            <button
              type="button"
              class="dtp-nav-btn"
              aria-label="Další roky"
              (click)="nextYears()"
            >
              <i class="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
            </button>
          </div>
          <div class="dtp-years-grid" role="grid" aria-label="Výběr roku">
            @for (y of yearsGrid(); track y) {
              <button
                type="button"
                class="dtp-year"
                role="gridcell"
                [class.is-current]="isViewYear(y)"
                (click)="selectYear(y)"
              >
                {{ y }}
              </button>
            }
          </div>
        </div>
      } @else {
        <div class="dtp-grid" role="grid">
          @for (d of dayLabels; track d) {
            <div class="dtp-day-label" aria-hidden="true">{{ d }}</div>
          }
          @for (day of calendarDays(); track day.date.toISOString()) {
            <button
              type="button"
              class="dtp-day"
              role="gridcell"
              [attr.aria-label]="dayAria(day.date)"
              [attr.aria-selected]="isSel(day.date)"
              [attr.aria-current]="day.isToday ? 'date' : null"
              [class.out-of-month]="!day.inMonth"
              [class.is-today]="day.isToday"
              [class.is-selected]="isSel(day.date)"
              (click)="selectDay(day.date)"
            >
              {{ day.date.getDate() }}
            </button>
          }
        </div>
      }

      <div class="dtp-time">
        <div class="dtp-time-field">
          <button
            type="button"
            class="dtp-time-step"
            aria-label="Odečíst hodinu"
            (click)="changeHour(-1)"
          >
            −
          </button>
          <span class="dtp-time-value">{{ hourLabel() }}</span>
          <button
            type="button"
            class="dtp-time-step"
            aria-label="Přidat hodinu"
            (click)="changeHour(1)"
          >
            +
          </button>
        </div>
        <span class="dtp-time-separator">:</span>
        <div class="dtp-time-field">
          <button
            type="button"
            class="dtp-time-step"
            aria-label="Odečíst minutu"
            (click)="changeMinute(-1)"
          >
            −
          </button>
          <span class="dtp-time-value">{{ minuteLabel() }}</span>
          <button
            type="button"
            class="dtp-time-step"
            aria-label="Přidat minutu"
            (click)="changeMinute(1)"
          >
            +
          </button>
        </div>
      </div>

      <div class="dtp-footer">
        <button type="button" class="dtp-today-btn" (click)="goToday()">
          Dnes
        </button>
        <button type="button" class="dtp-confirm-btn" (click)="confirm()">
          Potvrdit
        </button>
      </div>
    </div>
</ng-template>
